module.exports = __webpack_public_path__ + "static/media/storageIcon.389e18ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Comp/img/storageIcon.svg
// module id = 101
// module chunks = 0